import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import BirthdaySettings from "../../components/BirthdaySettings";
import PageHelpGuide from "../../components/PageHelpGuide";
import { BIRTHDAY_HELP_DATA } from "../../constants/pageHelp/birthdayHelp";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 16,
    backgroundColor: theme.palette.type === "dark" ? "#2A2D32 !important" : theme.palette.background.paper,
  },
  scrollArea: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
}));

const BirthdaySettingsPage = () => {
  const classes = useStyles();

  return (
    <MainContainer>
      <Paper className={classes.mainPaper} variant="outlined">
        <MainHeader>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <PageHelpGuide
              helpData={BIRTHDAY_HELP_DATA}
              tooltipText="Guía y Ayuda de Cumpleaños (Haz clic para ver)"
            />
            <Title>{i18n.t("birthdaySettings.title")}</Title>
          </div>
        </MainHeader>
        <div className={classes.scrollArea}>
          <BirthdaySettings />
        </div>
      </Paper>
    </MainContainer>
  );
};

export default BirthdaySettingsPage;
